import { render, staticRenderFns } from "./ButtonForm.vue?vue&type=template&id=5b5307d8"
import script from "./ButtonForm.vue?vue&type=script&lang=js"
export * from "./ButtonForm.vue?vue&type=script&lang=js"
import style0 from "./ButtonForm.vue?vue&type=style&index=0&id=5b5307d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports